import React from 'react';
import PageWorkInProgress from '../../../../components/utils/page-work-in-progress/pageWorkInProgress';
// Feature is discribed here : https://www.figma.com/file/w6SqrbNqPpuwgQL1BHoM3d/Govrn---UI?node-id=6509%3A72324
const SharePost = () => {
    return <PageWorkInProgress />;
};
export default SharePost;
